/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_Live_CaptioningInputs */

const en_options_quicktools_live_captioning = /** @type {(inputs: Options_Quicktools_Live_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Captioning`)
};

const fr_options_quicktools_live_captioning = /** @type {(inputs: Options_Quicktools_Live_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titrage en direct`)
};

const de_options_quicktools_live_captioning = /** @type {(inputs: Options_Quicktools_Live_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Untertitelung`)
};

const it_options_quicktools_live_captioning = /** @type {(inputs: Options_Quicktools_Live_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitoli in diretta`)
};

const ru_options_quicktools_live_captioning = /** @type {(inputs: Options_Quicktools_Live_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Субтитры в реальном времени`)
};

const es_options_quicktools_live_captioning = /** @type {(inputs: Options_Quicktools_Live_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitulado en directo`)
};

const zh_cn2_options_quicktools_live_captioning = /** @type {(inputs: Options_Quicktools_Live_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实时字幕`)
};

const ja_options_quicktools_live_captioning = /** @type {(inputs: Options_Quicktools_Live_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブキャプション`)
};

const hi_options_quicktools_live_captioning = /** @type {(inputs: Options_Quicktools_Live_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव कैप्शनिंग`)
};

const pt_pt2_options_quicktools_live_captioning = /** @type {(inputs: Options_Quicktools_Live_CaptioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendas ao vivo`)
};

/**
* | output |
* | --- |
* | "Live Captioning" |
*
* @param {Options_Quicktools_Live_CaptioningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_live_captioning = /** @type {((inputs?: Options_Quicktools_Live_CaptioningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_Live_CaptioningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_quicktools_live_captioning(inputs)
	if (locale === "de") return de_options_quicktools_live_captioning(inputs)
	if (locale === "it") return it_options_quicktools_live_captioning(inputs)
	if (locale === "ru") return ru_options_quicktools_live_captioning(inputs)
	if (locale === "es") return es_options_quicktools_live_captioning(inputs)
	if (locale === "zh-CN") return zh_cn2_options_quicktools_live_captioning(inputs)
	if (locale === "ja") return ja_options_quicktools_live_captioning(inputs)
	if (locale === "hi") return hi_options_quicktools_live_captioning(inputs)
	if (locale === "pt-PT") return pt_pt2_options_quicktools_live_captioning(inputs)
	return en_options_quicktools_live_captioning(inputs)
});